<template>
  <b-table responsive id="agent-report" small :items="items" :fields="columns" no-sort-reset foot-clone>
    <!-- Content -->
    <template #cell(closed_volume)="row">
      {{ row.item.closed_volume | currency }}
    </template>
    <template #cell(pending_volume)="row">
      {{ row.item.pending_volume | currency }}
    </template>
    <template #cell(average_sale_price)="row">
      {{ row.item.average_sale_price | currency }}
    </template>
    <template #cell(closed_gci)="row">
      {{ row.item.closed_gci | currency }}
    </template>
    <template #cell(pending_gci)="row">
      {{ row.item.pending_gci | currency }}
    </template>
    <template #cell(closed_company_gci)="row">
      {{ row.item.closed_company_gci | currency }}
    </template>
    <template #cell(pending_company_gci)="row">
      {{ row.item.pending_company_gci | currency }}
    </template>
    <template #cell(closed_agent_gci)="row">
      {{ row.item.closed_agent_gci | currency }}
    </template>
    <template #cell(pending_agent_gci)="row">
      {{ row.item.pending_agent_gci | currency }}
    </template>

    <!-- Footers -->
    <template #foot(month)="row">
      Totals:
    </template>
    <template #foot(quarter)="row">
      Totals:
    </template>
    <template #foot(units_closed)="row">
      {{ total_closed }}
    </template>
    <template #foot(units_pending)="row">
      {{ total_pending }}
    </template>
    <template #foot(closed_volume)="row">
      {{ closed_volume | currency }}
    </template>
    <template #foot(pending_volume)="row">
      {{ pending_volume | currency }}
    </template>
    <template #foot(average_sale_price)="row">
      {{ average_sale_price | currency }}
    </template>
    <template #foot(closed_gci)="row">
      {{ closed_gci | currency }}
    </template>
    <template #foot(pending_gci)="row">
      {{ pending_gci | currency }}
    </template>
    <template #foot(closed_company_gci)="row">
      {{ closed_company_gci | currency }}
    </template>
    <template #foot(pending_company_gci)="row">
      {{ pending_company_gci | currency }}
    </template>
    <template #foot(closed_agent_gci)="row">
      {{ closed_agent_gci | currency }}
    </template>
    <template #foot(pending_agent_gci)="row">
      {{ pending_agent_gci | currency }}
    </template>
  </b-table>
</template>

<script>
import columns from '@/views/Components/Reports/agentProductionColumns.js';

export default {
  props: {
    items: null
  },
  data() {
    return {
      columns: columns
    }
  },
  computed: {
    total_closed() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.units_closed);
      }, 0);
    },
    total_pending() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.units_pending);
      }, 0);
    },
    closed_volume() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.closed_volume);
      }, 0);
    },
    pending_volume() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.pending_volume);
      }, 0);
    },
    average_sale_price() {
      if(this.items.length == 0) {
        return 0;
      }

      const closed_units = this.total_closed + this.total_pending;
      const volume = this.closed_volume + this.pending_volume;

      return volume / closed_units;
    },
    closed_gci() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.closed_gci);
      }, 0);
    },
    pending_gci() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.pending_gci);
      }, 0);
    },
    closed_company_gci() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.closed_company_gci);
      }, 0);
    },
    pending_company_gci() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.pending_company_gci);
      }, 0);
    },
    closed_agent_gci() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.closed_agent_gci);
      }, 0);
    },
    pending_agent_gci() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.pending_agent_gci);
      }, 0);
    },
  }
};
</script>